import React from 'react';

import { CloseCircle } from 'iconsax-react';
import { UploadedImage } from '../../../../types/chat';
import LoaderSpin from '../../../../components/atoms/LoaderSpin';

interface ImagePreviewProps {
  images: UploadedImage[];
  onRemove: (uid: string) => void;
}

const ImagePreview = ({ images, onRemove }: ImagePreviewProps) => {
  if (images.length === 0) return null;

  return (
    <div className="flex gap-2 mt-2 overflow-x-auto pb-2">
      {images.map((image) => (
        <div
          key={image.uid}
          className="relative w-16 h-16 rounded-lg overflow-hidden group"
        >
          <img
            src={image.url}
            alt={image.name}
            width={64}
            height={64}
            className="object-cover w-full h-full"
          />
          {image.status === 'uploading' && (
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
              <LoaderSpin />
            </div>
          )}
          <button
            onClick={() => onRemove(image.uid)}
            className="absolute top-1 right-1 bg-black/50 text-white rounded-full w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <CloseCircle
              className="text-light-text-primary dark:text-dark-text-primary"
              variant="Bold"
            />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ImagePreview;
